export function isValidID(value) {
  const regex = new RegExp("[\\d]{1,2}[\\d]{3}[\\d]{3}", "gm")
  const match = regex.exec(value)

  if (!match) return false

  return true
}
